import mixpanel from 'mixpanel-browser';

const isProduction = process.env.NODE_ENV === 'production';
const token = process.env.VUE_APP_MIXPANEL_TOKEN;

export const mixpanelService = {
  init() {
    if (!token) {
      console.warn('Mixpanel token is missing');
      return;
    }

    mixpanel.init(token, {
      debug: !isProduction,
      track_pageview: true,
      persistence: 'localStorage',
      ip: true
    });
  },

  alias(id) {
    mixpanel.alias(id);
  },

  identify(userId, userDetails = {}) {
    mixpanel.identify(userId);
    // Only set people properties if userDetails is not empty
    if (Object.keys(userDetails).length > 0) {
        mixpanel.people.set(userDetails);
    }
  },

  track(eventName, properties = {}) {
    mixpanel.track(eventName, properties);
  },

  reset() {
    mixpanel.reset();
  },

  /**
   * Track an event as a new user without affecting the current user's session
   */
  trackAsNewUser(userId, userDetails, eventName, eventProperties) {
    if (!token) return;

    // Create a new ghost instance
    const ghostName = 'ghost_tracker';
    
    mixpanel.init(token, {
      persistence: 'memory', 
      ignore_dnt: true
    }, ghostName); 

    // Identify the new user
    mixpanel[ghostName].identify(userId);

    // Set people properties for the new user
    if (Object.keys(userDetails).length > 0) {
      mixpanel[ghostName].people.set(userDetails);
    }

    // Track the event for the new user
    mixpanel[ghostName].track(eventName, eventProperties);
  }
};